import { HttpClientModule } from '@angular/common/http';
import { Injector, NgModule, enableProdMode } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataAccessSharedModule } from '@coach-bot/data-access/shared';
import { AntipatternModule } from '@coach-bot/features/antipattern';
import { StudentModule } from '@coach-bot/features/student';
import { ENVIRONMENT_TOKEN, Environment, EnvironmentType, initializeAngularEnvironment } from '@environment';
import { TranslateModule } from '@ngx-translate/core';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ExtensionModule } from '@shared/extension';
import { SharedUIModule } from '@shared/ui';
import player, { LottiePlayer } from 'lottie-web';
import { LottieModule } from 'ngx-lottie';
import { AppComponent } from './components';
import { AppSubscriptionsService } from './services';

function playerFactory(): LottiePlayer {
  return player;
}

const environment: Environment = initializeAngularEnvironment();
if (environment.type === EnvironmentType.Production) {
  enableProdMode();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AntipatternModule,
    BrowserModule,
    BrowserAnimationsModule,
    DataAccessSharedModule.forRoot(environment),
    ExtensionModule,
    HttpClientModule,
    IconsModule,
    LottieModule.forRoot({
      player: playerFactory,
    }),
    SharedUIModule,
    StudentModule,
    TranslateModule.forRoot(),
  ],
  providers: [{ provide: ENVIRONMENT_TOKEN, useValue: environment }, AppSubscriptionsService],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
  }

  ngDoBootstrap(): void {
    const rootWebComponent = createCustomElement(AppComponent, { injector: this.injector });
    customElements.define('da-extension', rootWebComponent);
  }
}
